export default __webpack_public_path__ + "static/media/format_study3.44569fc0.svg";